/*
 * File: d:\projects\AutoFiFront\src\Content\AboutUs\Values\Values.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 18th 2023 9:49:42 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { ReactNode } from 'react';
import Styles from 'Content/AboutUs/Values/Values.module.css';
import translator from 'MultiLanguage/TranslationWrapper';
import { getThemeColor } from 'Utils/ThemeColor';

type ValuesProps = {
    text: string,
    icon: ReactNode,
    themeColor: string
};

function Values(props: ValuesProps) {
    const color = getThemeColor(props.themeColor);

    return (
        <div className={`${Styles.box}`}>
            <div className={`${Styles.boxIcon}`}>
                {props.icon}
            </div>
            <p className={`m-0`} style={{color: color}} >
                {translator.decode(`aboutUs.${props.text}`)}
            </p>
        </div>
    );
}

export default Values;
